// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconIndex } from '../api/IconIndex';

const Icon = ({ icon, ...props }) => {
    return IconIndex[icon] ? <FontAwesomeIcon icon={IconIndex[icon]} {...props} /> : null;
}

export default Icon;